<template>
  <el-table
    ref="innerTable"
    :data="data"
    stripe
    highlight-current-row
    border
    style="width: 100%"
    :cell-style="cellStyle"
    v-bind="$attrs"
    v-on="listeners"
    @selection-change="handleSelectionChange">
    <el-table-column
      v-if="showSelection"
      type="selection"
      width="40"
      :selectable="rowSelectableHandler">
    </el-table-column>
    <el-table-column label="ID" width="70">
      <template slot-scope="scope">
        <router-link v-if="showIdLink" :to="`/payment-center/detail/${scope.row.id}`">
          <span size="mini">{{ scope.row.id }}</span>
        </router-link>
        <span v-else>{{ scope.row.id }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-for="(attr, index) in fields"
      :key="index"
      v-bind="attr">
    </el-table-column>
    <el-table-column
      v-if="showOperationColumn"
      fixed="right"
      :label="operationColumnLabel"
      :width="operationColumnWidth">
      <template slot-scope="scope">
        <slot name="operation" :row="scope.row"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import paymentCenterMixins from '../payment-center.mixins'
import request from '@core/api/request'

export default {
  name: 'PaymentCenterTableList',
  mixins: [paymentCenterMixins],
  inheritAttrs: false,
  data () {
    return {
      paymentCompanys: {},
    }
  },
  async created () {
    await this.getFinCenterConfigs()
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    cellStyle: {
      type: [Function, Object],
      default: null,
    },
    showSelection: {
      type: Boolean,
      default: true,
    },
    rowSelectable: {
      type: Function,
      default: () => true,
    },
    showOperationColumn: {
      type: Boolean,
      default: false,
    },
    operationColumnLabel: {
      type: String,
      default: '操作',
    },
    operationColumnWidth: {
      type: [Number, String],
      default: 220,
    },
    showIdLink: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    listeners () {
      const listeners = { ...this.$listeners }
      delete listeners['selection-change']
      return listeners
    },
  },
  methods: {
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupPaymentCompany(data)
      })
    },
    setupPaymentCompany (data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    rowSelectableHandler (row, index) {
      return this.rowSelectable ? this.rowSelectable(row, index) : true
    },
    handleSelectionChange (val) {
      this.$emit('selection-change', val)
    },
    clearSelection () {
      if (this.$refs.innerTable) {
        this.$refs.innerTable.clearSelection()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/payment-center/components/PaymentCenterTableList.vue